<template>
  <div class="app-container">
    <transition name="pages">
      <router-view></router-view>
    </transition>
    <appFooter></appFooter>
    <blumarloading></blumarloading>
    <blumaralert></blumaralert>
  </div>
</template>

<script>
import BlumarLoading from "./components/shared/BlumarLoading.vue";
import BlumarAlert from "./components/shared/BlumarAlert.vue";
import Footer from "./components/shared/footer/Footer.vue";

export default {
  components: {
    blumarloading: BlumarLoading,
    blumaralert: BlumarAlert,
    appFooter: Footer
  },
};
</script>

<style lang="scss">
@import './bootstrap-theming.scss';

.pages-enter,
.pages-leave-active {
  opacity: 0;
}
.pages-enter-active,
.pages-leave-active {
  transition: opacity 0;
}
.container > .module-welcome {
  margin-top: 20%;
  text-align: center;
}
table.table-list {
  margin-top: 5%;
}
thead.list th {
  border-top: 0 !important;
  background-color: transparent !important;
}
.form-group > label {
  font-weight: bold;
}
h3 {
  font-size: 1.5rem;
  font-weight: 400;
}
.actions i {
  cursor: pointer;
  color: #000;
}
.actions i:hover {
  font-weight: bold;
}
a:link,
a:visited {
  text-decoration: none !important;
}
.vertical-scrollable {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
.horizontal-scrollable {
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}
.modal-content {
  padding: 10px !important;
  border: 0px;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 1px; /*Truque para o ellipses funcionar com coluna percentual*/
}
.capitalize {
  text-transform: capitalize;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue